export class Process {
    constructor(){
        this.record_id = 0;
        this.channel_id = "";
        this.description = "";
        this.status = "";
        this.narrative ="";
        this.user_reference_a = "";
        this.user_reference_b = "";
        this.user_reference_c = "";
        this.active_yn = true;
        this.sequence = 0;
    }

    record_id: number;
    channel_id: string;
    description: string;
    status: string;
    narrative: string;
    user_reference_a: string;
    user_reference_b: string;
    user_reference_c: string;
    active_yn: boolean;
    sequence: number;
    add_user_id: string;
    add_user_name: string;
    add_date_time: string;
    add_ip: string;
    add_browser: string;
    upd_date_time: string;
    upd_ip: string;
    upd_browser: string
  }